import React, { useContext, useEffect, useState, useRef } from "react";
import style from "./index.module.scss";
import PubSub from "pubsub-js";


import Api from "@/common/Api/accountManage";
import messageApi from "@/common/Api/message";

import { paddingNum, formatMediaName, discordRuleRE, defaultErrorMessage } from "@/common/utils";
import { rootContext, globalData, mainOfGame, isFl84 } from "@/context/rootContext";
import { informationData } from "@/assets/data/pageData";
import counterList from "@/assets/data/countryCodes";

import dislyte_dark from "@/assets/images/dislyte_logo_dark.png";
import farlight84_dark from "@/assets/images/farlight84_dark.png";
import igame_en_dark from "@/assets/images/igame_en_dark.png";
import filterGameData from "@/common/filter/gameDataFilter";
import { Modal } from "antd";
import { useLocation } from "react-router-dom";

const maskDarkIcon = {
  dislyte: dislyte_dark,
  farlight84: farlight84_dark,
  igame: igame_en_dark
};
const gameIcons = filterGameData("gameIcons");

function Information() {

  const location = useLocation();
  const [dayList, setDayList] = useState([]);
  const [monthList] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
  const [yearList, setYearList] = useState([]);
  const [chooseYear, setChooseYear] = useState(1900);
  const [chooseMonth, setChooseMonth] = useState(1);
  const [chooseDay, setChooseDay] = useState(1);
  const [chooseCounter, setChooseCounter] = useState("");
  const [discode, setDiscode] = useState([]);
  const [isChange, setIsChange] = useState(false);
  const changeTime = useRef(null);
  const [gameList2, setGameList2] = useState([]);
  const [creatorLanguage, setCreatorLanguage] = useState("");
  const [mediaList, setMediaList] = useState([]);
  const [discoreChangeBtn, setDiscoreChangeBtn] = useState(false);
  const [discoreSaveTip1, setDiscoreSaveTip1] = useState(false);
  const [discoreSaveTip2, setDiscoreSaveTip2] = useState(false);
  const [discoreSaveTip3, setDiscoreSaveTip3] = useState("");
  const { creatorData, setDialogIndex, setVerify, setCreatorData, setAblePos, gameList, ableLanguage } = useContext(rootContext);
  const firstNameRef = useRef();
  const lastNameRef = useRef();

  useEffect(() => {
    getPosList();

    const yearList = [];
    const dayList = [];
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const dayMax = new Date(year, month, 0).getDate();
    for (let i = 1900; i <= year; i++) {
      yearList.push(i);
    }
    for (let i = 1; i <= dayMax; i++) {
      dayList.push(i);
    }
    setYearList(yearList);
    setDayList(dayList);
    setChooseYear(year);
    setChooseMonth(month);
    setChooseDay(day);
  }, []);

  useEffect(() => {
    if (location.state && location.state.enter === "discord") {
      setTimeout(() => {
        if (window.location.href.indexOf("/information") > -1) {
          document.documentElement.scrollTo(0, document.querySelector("#root").clientHeight);
        }
      }, 400);
    }
  }, [location]);

  const changeYear = (e) => {
    const year = e.target.value;
    const indexTime = new Date(year, chooseMonth, 0).getDate();
    setChooseYear(year);
    setChooseDay(indexTime >= chooseDay ? chooseDay : 1);
    reSetDayList(year, chooseMonth);
  };

  const changeMonth = (e) => {
    const month = e.target.value;
    const indexTime = new Date(chooseYear, month, 0).getDate();
    setChooseMonth(month);
    setChooseDay(indexTime >= chooseDay ? chooseDay : 1);
    reSetDayList(chooseYear, month);
  };

  const changeDay = (e) => {
    setChooseDay(e.target.value);
  };

  const reSetDayList = (year, month) => {
    const datMax = new Date(year, month, 0).getDate();
    const dayList = [];
    for (let i = 1; i <= datMax; i++) {
      dayList.push(i);
    }
    setDayList(dayList);
  };

  const verifyPassword = () => {
    window.gtag("event", "pc_information_password");
    setVerify(true);
    setDialogIndex(6);
  };

  const verifyUserName = () => {
    // setNextDialog(10);
    window.gtag("event", "pc_information_username");
    setDialogIndex(10);
  };

  const enterDiscord = (value) => {
    if (value.length > discode.length && !/^\d*$/.test(value.replace(discode, ""))) {
      return;
    }
    setDiscode(value);
  };

  const saveDiscordChange = () => {
    if (discordRuleRE.test(discode)) {
      const data = {
        nickName: creatorData.nickName,
        birthday: `${chooseYear}-${paddingNum(chooseMonth, 2)}-${paddingNum(chooseDay, 2)}`,
        discord: discode,
        region: chooseCounter
      };
      saveChange(data, () => {
        setDiscoreChangeBtn(false);
        setDiscoreSaveTip1(false);
        setDiscoreSaveTip2(true);
        setDiscoreSaveTip3("");
        PubSub.publish("resetDiscordFinish", null);
        setTimeout(() => {
          setDiscoreSaveTip2(false);
          setDiscoreSaveTip3("");
        }, 1500);
      });
    } else {
      setDiscoreSaveTip1(true);
      setDiscoreSaveTip2(false);
      setDiscoreSaveTip3("");
    }
  };

  const getPosList = async () => {
    const res = await messageApi.getActivePosList();
    if (res.status === 200) {
      setAblePos(res.data);
    }
  };

  const saveThrottling = async () => {
    if (changeTime.value) {
      clearTimeout(changeTime.value);
      changeTime.value = null;
    }
    changeTime.value = setTimeout(() => {
      const data = {
        nickName: creatorData.nickName,
        birthday: `${chooseYear}-${paddingNum(chooseMonth, 2)}-${paddingNum(chooseDay, 2)}`,
        discord: discode,
        region: chooseCounter
      };
      saveChange(data);
    }, 600);
  };

  const saveChange = async (data, cb) => {
    // console.log(data);
    const res = await Api.modifyInformation(data);
    if (res.status === 200) {
      window.gtag("event", "pc_information_data");
      // PubSub.publish("resetUserData", null);
      creatorData.nickName = data.nickName;
      creatorData.birthday = data.birthday;
      creatorData.discord = data.discord;
      creatorData.region = data.region;
      setCreatorData({ ...creatorData });
      setDiscoreSaveTip3("");
      cb && cb();
    } else {
      if (res && res.data && res.data.code === 400204) {
        setDiscoreSaveTip3(res.data.message);
      } else {
        defaultErrorMessage(res, "mediaData");
      }
    }
  };

  const exangeRegionMedia = (region) => {
    console.log(region);
    globalData.activeRegion = region;
    setDialogIndex(12);
  };

  const exangeRegionGame = (region) => {
    globalData.activeRegion = region;
    setDialogIndex(11);
  };

  const editMedia = () => {
    if (!isFl84 && globalData.activeGameData.tag === "farlight84") {
      Modal.info({
        title: "TIP",
        width: "50vw",
        okText: "GO",
        content: (
          <>
            <p>Please visit the &quot;Farlight 84 Creator Zone&quot; to apply as a Farlight 84 Creator.</p>
            <p>&nbsp;</p>
            <p>Note: Your current account can still be used on the &quot;Farlight 84 Creator Zone&quot; website.</p>
          </>
        )
      });
      setTimeout(() => {
        const enter = document.getElementsByClassName("ant-btn-primary")[0];
        const a = document.createElement("a");
        a.setAttribute("href", "https://fl84.creator-zone.com/main/home");
        a.setAttribute("target", "_blank");
        a.setAttribute("rel", "opener");
        a.setAttribute("class", "primary-link");
        enter.appendChild(a);
      }, 100);
      return;
    }
    setDialogIndex(12);
  };

  useEffect(() => {
    if (creatorData && gameList.length) {
      setDiscode(creatorData.discord || "");
      setChooseCounter(creatorData.region || window.localStorage.getItem("lilacRegion"));
      if (creatorData && creatorData.birthday) {
        const time = new Date(creatorData.birthday);
        setChooseYear(+time.getFullYear());
        setChooseMonth(+time.getMonth() + 1);
        setChooseDay(+time.getDate());
      }
      if (creatorData.realInfo && creatorData.realInfo.length) {
        firstNameRef.current.innerHTML = creatorData.realInfo[0].realName.split(" ")[0];
        lastNameRef.current.innerHTML = creatorData.realInfo[0].realName.split(" ")[1];
      }
      if (creatorData.language) {
        const langTag = ableLanguage.filter(item => item.code === creatorData.language)[0];
        if (langTag) {
          setCreatorLanguage(langTag.language);
        }
      }
      if (creatorData.games.length && creatorData.realInfo.length) {
        const activePlatform = creatorData.realInfo.map((item) => item.platform);
        const gameList2 = creatorData.games.filter(item => activePlatform.includes(item.platform));
        if (!mainOfGame) {
          setGameList2(gameList2);
        } else {
          const gameList = {};
          for (const item of creatorData.games) {
            if (!gameList[item.regionName]) { gameList[item.regionName] = []; }
            gameList[item.regionName].push(item);
          }
          setGameList2(gameList);
        }
      }
      if (mainOfGame && creatorData.mInfos && creatorData.mInfos.length) {
        const regionList = {};
        for (const item of creatorData.mInfos) {
          if (!regionList[item.regionName]) { regionList[item.regionName] = []; }
          regionList[item.regionName].push(item);
        }
        setMediaList(regionList);
      }
    }
  }, [creatorData, gameList]);

  useEffect(() => {
    if (isChange) {
      saveThrottling();
    }
  }, [chooseCounter, chooseYear, chooseMonth, chooseDay, discode, changeTime]);

  return (
    <section>
      <div className={style.information_content} onClick={() => { setDiscoreChangeBtn(false); }}>
        <div className={style.title}>{ informationData.title1 }</div>
        <div className={style.content_1}>
          <div className={style.base_information}>
            <div className={style.sub_title}>{ informationData.accountTitle }</div>
            <div className={style.input_box}>
              <input readOnly value={creatorData ? (creatorData.email || "") : ""}></input>
            </div>
            <div className={style.input_box}>
              <input readOnly value={creatorData ? (creatorData.nickName || creatorData.loginName || "") : ""}></input>
              <i className={style.next} onClick={verifyUserName}></i>
            </div>
            <div className={style.input_box}>
              <input type="password" readOnly value="********"></input>
              <i className={style.next} onClick={verifyPassword}></i>
            </div>
            <br />
            {
              !mainOfGame && (
                <>
                  <div className={style.sub_title}>{ informationData.mediaTitle }<i className={style.edit} onClick={editMedia}></i></div>
                  {
                    creatorData && creatorData.mInfos.map((item, index) => {
                      return (
                        <div className={`${style.input_box} ${style.input_box2}`} key={index}>
                          <i className={style[item.tag.toLowerCase()]}></i>
                          <span>{formatMediaName(item.tag)}</span>
                          <span className={style.name}>{item.nickName}</span>
                        </div>
                      );
                    })
                  }
                </>
              )
            }
            {
              mainOfGame &&
              <>
                <div className={style.sub_title}>{ informationData.mediaTitle }
                  {
                    !Object.keys(mediaList).length ? <i className={style.edit} onClick={editMedia}></i> : ""
                  }
                </div>
                {
                  <ul className={style.mediaList}>
                    {
                      Object.keys(mediaList).map((item, index) => {
                        return (
                          <>
                            <p className={style.subTitle}>{item}<i className={style.edit} onClick={() => { exangeRegionMedia(mediaList[item][0].regionId); }}></i></p>
                            <li key={index}>
                              {
                                mediaList[item].map((subItem) => (
                                  <div className={`${style.input_box} ${style.input_box2}`} key={subItem.id}>
                                    <i className={style[subItem.tag.toLowerCase()]}></i>
                                    <span>{formatMediaName(subItem.tag)}</span>
                                    <span className={style.name}>{subItem.nickName}</span>
                                  </div>
                                ))
                              }
                            </li>
                            <hr />
                          </>
                        );
                      })
                    }
                  </ul>
                }
              </>
            }
          </div>
          <div className={style.level_box}>
            <div className={`${style.level} ${style["level" + (+(globalData.activeGameData.accountLv || 1))]}`}></div>
            {
              globalData.activeGameData.tag === "farlight84" && (
                <p className={style.lv_name}>
                  { informationData.fl84StarLevel[globalData.activeGameData.accountLv - 1] }
                </p>
              )
            }
          </div>
        </div>
        <div className={style.content_2}>
          {
            !mainOfGame &&
            <>
              <div className={style.sub_title}>
                { informationData.gameTitle }
                { creatorData && creatorData.games.filter(item => item.tag === "farlight84" && !item.inEffect).length > 0 && <i className={style.tip}></i> }
                <i className={style.edit} onClick={() => { setDialogIndex(11); }}></i>
              </div>
              <div className={style.game_list}>
                {
                  gameList2.map((item) => {
                    return <GameItem item={item} key={item.id} />;
                  })
                }
              </div>
            </>
          }
          {
            mainOfGame &&
            <>
              <div className={style.sub_title}>
                { informationData.gameTitle }
              </div>
              <div className={style.game_list}>
                {
                  (
                    <ul className={style.gameList}>
                      {
                        Object.keys(gameList2).map((item, index) => {
                          return (
                            <>
                              <p className={style.subTitle}>
                                {item}
                                { gameList2[item].filter(item => item.tag === "farlight84" && !item.inEffect).length > 0 && <i className={style.tip}></i> }
                                <i className={style.edit} onClick={() => { exangeRegionGame(gameList2[item][0].regionId); }}></i>
                              </p>
                              <li key={index}>
                                {
                                  gameList2[item].map((subItem) => (
                                    <GameItem item={subItem} key={subItem.id} />
                                  ))
                                }
                              </li>
                              <hr />
                            </>
                          );
                        })
                      }
                    </ul>
                  )
                }
              </div>
            </>
          }
        </div>
        <div className={style.title}>{ informationData.title2 }</div>
        <div className={style.content_3}>
          <div className={style.sub_title}>{ informationData.birthdayTitle }</div>
          <ul>
            <li>
              <select value={chooseDay} onChange={(e) => { setIsChange(true); changeDay(e); }} disabled>
                {
                  dayList.map((item) => {
                    return (
                      <option key={item} value={item} >{item}</option>
                    );
                  })
                }
              </select>
            </li>
            <li>
              <select value={chooseMonth} onChange={(e) => { setIsChange(true); changeMonth(e); }} disabled>
                {
                  monthList.map((item) => {
                    return (
                      <option key={item} value={item} >{item}</option>
                    );
                  })
                }
              </select>
            </li>
            <li>
              <select value={chooseYear} onChange={(e) => { setIsChange(true); changeYear(e); }} disabled>
                {
                  yearList.map((item) => {
                    return (
                      <option key={item} value={item} >{item}</option>
                    );
                  })
                }
              </select>
            </li>
          </ul>
          <ul className={style.real_name}>
            <div className={style.sub_title}>{ informationData.realNameTitle }</div>
            <li>
              <p>FIRSE NAME</p>
              <p ref={firstNameRef}></p>
            </li>
            <li>
              <p>LAST NAME</p>
              <p ref={lastNameRef}></p>
            </li>
          </ul>
          <ul className={style.country}>
            <div className={style.sub_title}>{ informationData.countryTitle }</div>
            <li className={style.down}>
              <select value={chooseCounter} onChange={(e) => { setIsChange(true); setChooseCounter(e.target.value); }}>
                {
                  counterList.country.map((item, index) => {
                    return (
                      <option key={index} value={item} >{item}</option>
                    );
                  })
                }
              </select>
            </li>
          </ul>
          <ul className={style.language}>
            <div className={style.sub_title}>{ informationData.languageTitle }</div>
            <p>{creatorLanguage || "English"}</p>
          </ul>
          <div className={style.discord}>
            <div className={style.sub_title}>{ informationData.discordTitle }</div>
            <p className={style.module_desc}>{ informationData.discordDesc }</p>
            <div className={style.discode_input}>
              <i className={style.discode_icon}></i>
              <input
                value={discode}
                maxLength={19}
                className={`${(discode && discordRuleRE.test(discode)) ? style.active : ""}`}
                onChange={(e) => { enterDiscord(e.target.value); }}
                onFocus={(e) => { setDiscoreChangeBtn(true);e.stopPropagation(); }}
                onClick={(e) => { e.stopPropagation(); }}
              ></input>
              <i className={style.gou}></i>
              <i className={style.tip} onClick={() => { setDialogIndex(26); }}>?</i>
              {
                discoreChangeBtn ? (
                  <div
                    className={`${style.saveDiscordBtn} ${discordRuleRE.test(discode) ? style.on : ""}`}
                    onClick={(e) => { saveDiscordChange();e.stopPropagation(); }}
                    onTouchEnd={(e) => { saveDiscordChange();e.stopPropagation(); }}
                  >submit</div>
                ) : ""
              }
              {
                (discoreSaveTip1 || discoreSaveTip3) ? (
                  <p className={style.discordChangeTip}>
                    { discoreSaveTip3 || "Discord UID must be 18 or 19 digits. Please try again."}
                  </p>
                ) : ""
              }
              {
                (!discoreChangeBtn && discoreSaveTip2) ? (
                  <p className={`${style.discordChangeTip} ${style.success}`}>Submission Successful.</p>
                ) : ""
              }
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Information;



function GameItem(props) {
  return (
    <div className={style.game_item}>
      <div className={style.game_logo}>
        <img src={maskDarkIcon[props.item.tag] || gameIcons[props.item.tag] || props.item.icon || ""}></img>
      </div>
      <div className={style.user_desc}>
        <p>{informationData.uid}:&nbsp;{props.item.uid}</p>
        <p>{props.item.partName}</p>
      </div>
      <p className={style.tab_title}>{informationData.tag}</p>
      <ul className={style.tab_list}>
        {
          props.item.activePoz.map((subItem, subIndex) => {
            return <li key={subIndex}>{subItem.activePos}</li>;
          })
        }
      </ul>
    </div>
  );
}